import { useState, useRef, ReactChild, useCallback } from 'react';

import styles from './KnmSignInfoMoreAccordion.module.scss';

interface IKnmSignInfoMoreAccordionProps {
  children: ReactChild | ReactChild[];
}

export const KnmSignInfoMoreAccordion = ({ children }: IKnmSignInfoMoreAccordionProps) => {
  const [isActive, setIsActiveState] = useState(false);
  const [setHeight, setHeightState] = useState('0px');
  const contentRef = useRef<HTMLDivElement>(null);

  const toggleAccordion = useCallback(() => {
    setIsActiveState(!isActive);
    let height = '0px';

    if (!isActive && contentRef && contentRef.current) {
      const current = contentRef.current || {
        scrollHeight: 0,
      };

      height = `${current.scrollHeight}px`;
    }
    setHeightState(height);
  }, [isActive]);

  return (
    <div className={styles.KnmSignInfoMoreAccordion}>
      <button className={styles.ShowMore} type="button" onClick={toggleAccordion}>
        Подробнее
      </button>

      <div className={styles.AccordionContent} ref={contentRef} style={{ maxHeight: `${setHeight}` }}>
        {children}
      </div>
    </div>
  );
};
